<template>
    <b-card id="EditarParticipantesVencedoresItensLicitacao" class="mx-5" bg-variant="light" no-body>
        <template #header>
            <h6 class="mb-0 titulo-sagres font-weight-bold" :class="{ 'text-left': !ro }">
                Vencedores do item
                <b-button v-if="!ro" size="sm" class="float-right m-1" @click="criarNovoVencedor"
                    :disabled="existeEdicaoVencedor || itemComVencedores.FlFracassado === 'Sim'">
                    <font-awesome-icon icon="plus" class="mr-3" />
                    Adicionar Vencedor
                </b-button>
            </h6>
        </template>
        <validation-observer ref="validationobserver" v-slot="{ handleSubmit }">
            <b-form @submit.prevent="handleSubmit(salvar)">
                <b-table :fields="fieldsVencedores" :items="itemComVencedores.Vencedores" :busy="tableBusyItens"
                    :current-page="currentPageItens" hover no-border-collapse striped small sort-by="" stacked="sm"
                    responsive show-empty class="overflowme">
                    <template #empty>
                        <span>Não foram encontrados dados.</span>
                    </template>
                    <template #emptyfiltered>
                        <span>Não foram encontrados dados.</span>
                    </template>
                    <template #table-busy>
                        <div class="text-center text-dark">
                            <b-spinner class="align-middle"></b-spinner>
                            <strong class="loading-text">Carregando...</strong>
                        </div>
                    </template>
                    <template #cell(Vencedor)="data">
                        <table-form-validation-provider v-if="data.item.modoEdicao" :hasLabel="false" tag="div"
                            v-slot="defaultState">
                            <div id="participanteSelectWrapper" class="wrapper-multiselect-sagres"
                                :class="{ 'invalid': participanteSelecionado === '', 'valid': participanteSelecionado !== '' }">
                                <multiselect v-model="participanteSelecionado" close-on-select searchable
                                    :show-labels="false" label="NmParticipante" deselect-label="" :allow-empty="true"
                                    placeholder="Selecione um" track-by="IdParticipanteLicitacao" :options="participantes"
                                    class="w-100" :disabled="data.item.loading" :state="defaultState.state">
                                    <template slot="noOptions">
                                        <small><i>Nenhum participante cadastrado</i></small>
                                    </template>
                                    <template slot="noResult">
                                        <i>Nenhum participante encontrado</i>
                                    </template>
                                </multiselect>
                            </div>
                        </table-form-validation-provider>
                        <span v-else>{{ data.value }}</span>
                    </template>
                    <template #cell(NmMarcaItemMatServ)="data">
                        <table-form-validation-provider v-if="data.item.modoEdicao" rules="max:100" v-slot="defaultState">
                            <b-form-input :disabled="data.item.loading" v-model="data.item.novaMarca"
                                :state="defaultState.state" />
                        </table-form-validation-provider>
                        <span v-else>{{ data.value }}</span>
                    </template>
                    <template #cell(QtLicitada)="data">
                        <table-form-validation-provider v-if="data.item.modoEdicao" v-slot="defaultState">
                            <b-form-input :disabled="data.item.loading" v-model="data.item.novaQtde" v-bind="licitaQtdProps"
                                :state="defaultState.state" />
                        </table-form-validation-provider>
                        <span v-else>{{ data.value }}</span>
                    </template>
                    <template #cell(VlUnitarioLicitado)="data">
                        <table-form-validation-provider v-if="data.item.modoEdicao" v-slot="defaultState">
                            <money class="form-control" :disabled="data.item.loading" v-model="data.item.novoValorUnit"
                                :state="defaultState.state" v-bind="vMoney4CasasOptions" />
                        </table-form-validation-provider>
                        <span v-else>{{ data.value }}</span>
                    </template>
                    <template #cell(DtHomologacaoItem)="data">
                        <table-form-validation-provider v-if="data.item.modoEdicao" v-slot="defaultState">
                            <b-form-datepicker v-model="data.item.novaDtHomologacaoItem" :state="defaultState.state"
                                v-bind="datePickerProps">
                            </b-form-datepicker>
                        </table-form-validation-provider>
                        <span v-else>{{ data.value }}</span>
                    </template>
                    <template v-slot:cell(actions)="row">
                        <b-overlay v-if="row.item.modoEdicao" :show="row.item.loading" variant="transparent" opacity="0.8"
                            blur="1px">
                            <div class="actions-icons">
                                <b-button type="submit" variant="link" class="text-dark py-0 px-2"
                                    :disabled="!row.item.isPreenchido()">
                                    <font-awesome-icon icon="save" />
                                    <div style="font-size: 12px">Salvar</div>
                                </b-button>
                                <b-link class="text-dark" @click="pararEdicaoVencedorItem(row.item)">
                                    <font-awesome-icon icon="cancel" />
                                    <div style="font-size: 12px">Cancelar {{ row.item.Vencedor ? 'edição' : '' }}
                                    </div>
                                </b-link>
                            </div>
                        </b-overlay>
                        <div v-else class="actions-icons">
                            <b-link :disabled="existeEdicaoVencedor" class="text-dark"
                                @click="editarVencedorItem(row.item)">
                                <font-awesome-icon icon="edit" />
                                <div style="font-size: 12px">Editar vencedor</div>
                            </b-link>
                            <btn-excluir :idItem="row.item" :excluirItem="removerVencedorItem" />
                        </div>
                    </template>
                </b-table>
            </b-form>
        </validation-observer>
        <table-pagination v-if="totalRowsItens > pageSize" :total-rows="totalRowsItens" :per-page="pageSize"
            class="ml-3 mb-1" :firstCurrentPg="currentPageItens" @pageChange="pageChange" />
    </b-card>
</template>

<script lang="ts">
import TablePagination from "@/components/atos-pessoal/TablePagination.vue"
import TableFormValidationProvider from '@/components/shared/TableFormValidationProvider.vue'
import BtnExcluir from '@/components/shared/btn-excluir.vue'
import ldiService from '@/services/licitacoes/ldiService'
import { DatePickerDefaultProps, Decimal32dot2Props } from '@/types/form-default-props'
import { fieldEdicaoVencedoresItem, fieldsVencedoresItem, fieldsVencedoresItemHmlParcial } from '@/types/licitacoes/ldi/fields-item-licitacao'
import { LicitacaoVencedorItem } from '@/types/licitacoes/ldi/licitacao-vencedor-item'
import { ParticipanteLicitacao } from '@/types/licitacoes/ldi/participante-licitacao'
import { VencedorItem } from '@/types/licitacoes/ldi/vencedor-item'
import { TableField } from '@/types/table-field'
import { UtilsTS } from '@/utilsts'
import { Money } from 'v-money'
import { ValidationObserver } from "vee-validate"
import { mixins } from 'vue-class-component'
import Multiselect from 'vue-multiselect'
import { Component, Vue } from 'vue-property-decorator'

const CompProps = Vue.extend({
    name: 'EditarParticipantesVencedoresItensLicitacao',
    components: {
        BtnExcluir,
        Money,
        Multiselect,
        TableFormValidationProvider,
        TablePagination,
        ValidationObserver,
    },
    props: {
        itemComVencedores: {
            type: LicitacaoVencedorItem,
            required: true
        },
        hmlParcial: {
            type: String,
            default: 'N'
        },
        ro: {
            type: Boolean,
            default: false
        }
    }
})

@Component
export default class EditarParticipantesVencedoresItensLicitacao extends mixins(UtilsTS, CompProps) {
    licitaQtdProps = Decimal32dot2Props
    fieldsVencedores: TableField[] = [
        ...(this.isHomologacaoParcial ? fieldsVencedoresItemHmlParcial : fieldsVencedoresItem),
        ...(!this.ro ? [fieldEdicaoVencedoresItem] : []),
    ]
    participantes: ParticipanteLicitacao[] = []
    participanteSelecionado: ParticipanteLicitacao | string = ''
    pageSize = 5
    tableBusy = false
    currentPageItens = 1
    totalRowsItens = 0
    tableBusyItens = false

    datePickerProps = DatePickerDefaultProps

    get existeEdicaoVencedor() {
        return this.itemComVencedores.Vencedores.some(venc => venc.modoEdicao)
    }

    get isHomologacaoParcial() {
        return this.hmlParcial === 'S' || this.hmlParcial === 'Sim'
    }

    async mounted() {
        await this.buscarParticipantes()
        await this.loadData()
    }

    async loadData() {
        try {
            this.tableBusyItens = true
            this.totalRowsItens = this.itemComVencedores.Vencedores.length

            //console.log('load data Vencedores do Item: ', this.itemComVencedores)
        } finally {
            this.tableBusyItens = false;
        }
    }
    async pageChange(value) {
        this.currentPageItens = value;
        await this.loadData();
    }
    async editarVencedorItem(value: VencedorItem) {

        const meuParticipante = this.participantes.find(part => part.IdParticipanteLicitacao === value.IdParticipanteLicitacao)
        this.participanteSelecionado = Object.assign(new ParticipanteLicitacao(), meuParticipante)

        const meuVencedorItem = this.itemComVencedores.Vencedores.find(part => part.IdParticipanteLicitacao === value.IdParticipanteLicitacao)

        if (meuVencedorItem) {
            meuVencedorItem.modoEdicao = true
            meuVencedorItem.novaMarca = meuVencedorItem.novaMarca || meuVencedorItem.NmMarcaItemMatServ
            meuVencedorItem.novoValorUnit = meuVencedorItem.novoValorUnit || meuVencedorItem.VlUnitarioLicitado
            meuVencedorItem.novaQtde = meuVencedorItem.novaQtde || meuVencedorItem.QtLicitada
            meuVencedorItem.novaDtHomologacaoItem = meuVencedorItem.novaDtHomologacaoItem || meuVencedorItem.DtHomologacaoItem
        }
    }
    pararEdicaoVencedorItem(vencedorItem: VencedorItem) {
        //console.log("parar edição do vencedor: ", vencedorItem)

        if (vencedorItem.IdParticipanteItemLicitacao) {
            const meuVencedorItem = this.itemComVencedores.Vencedores.find(part => part.IdParticipanteItemLicitacao === vencedorItem.IdParticipanteItemLicitacao)
            if (meuVencedorItem) {
                meuVencedorItem.modoEdicao = false
            }
        } else {
            //console.log(vencedorItem, vencedorItem.IdParticipanteItemLicitacao)
            this.itemComVencedores.Vencedores = this.itemComVencedores.Vencedores.filter(l => l.IdParticipanteItemLicitacao !== undefined)
            this.$emit('input', this.itemComVencedores.Vencedores);
        }
    }
    async salvar() {
        const meuVencedorItem = this.itemComVencedores.Vencedores.find(lo => lo.modoEdicao)
        try {
            if (meuVencedorItem) {
                meuVencedorItem.loading = true
                const vencedorAtualizado = new VencedorItem(meuVencedorItem)
                if (this.isHomologacaoParcial) {
                    vencedorAtualizado.DtHomologacaoItem = meuVencedorItem.novaDtHomologacaoItem
                }
                vencedorAtualizado.NmMarcaItemMatServ = meuVencedorItem.novaMarca
                vencedorAtualizado.VlUnitarioLicitado = meuVencedorItem.novoValorUnit
                vencedorAtualizado.QtLicitada = meuVencedorItem.novaQtde
                if (this.participanteSelecionado instanceof ParticipanteLicitacao && this.participanteSelecionado.IdParticipanteLicitacao)
                    vencedorAtualizado.IdParticipanteLicitacao = this.participanteSelecionado.IdParticipanteLicitacao

                const retorno = await ldiService.alterarVencedorItemLicitacao(this.itemComVencedores.IdItemLicitacao, vencedorAtualizado, 'S')
                if (retorno) {
                    this.itemComVencedores.Vencedores = this.itemComVencedores.Vencedores.filter(l => l.IdParticipanteItemLicitacao !== meuVencedorItem.IdParticipanteItemLicitacao)
                    this.itemComVencedores.Vencedores.unshift(retorno)
                    this.$toast.success(`Os dados do vencedor ${retorno.Vencedor} foram atualizados.`)
                    this.$emit('itemAtualizado');
                }
            }
        } catch (e: any) {
            this.tratarError(e)
        } finally {
            if (meuVencedorItem) meuVencedorItem.loading = false
        }
    }
    async removerVencedorItem(vencedorItem: VencedorItem) {
        //console.log('Remover item do lote: ', vencedorItem)
        try {
            const meuVencedorItem = this.itemComVencedores.Vencedores.find(lo => lo.IdParticipanteItemLicitacao === vencedorItem.IdParticipanteItemLicitacao)
            if (meuVencedorItem) {
                meuVencedorItem.loading = true

                //console.log('remover o vencedor do item: ', meuVencedorItem)

                const retorno = await ldiService.alterarVencedorItemLicitacao(this.itemComVencedores.IdItemLicitacao, meuVencedorItem, 'N')
                if (retorno) {
                    this.itemComVencedores.Vencedores = this.itemComVencedores.Vencedores.filter(p => p.IdParticipanteItemLicitacao !== vencedorItem.IdParticipanteItemLicitacao)
                    this.$emit('input', this.itemComVencedores.Vencedores);
                    this.$toast.success(`O vencedor ${vencedorItem.Vencedor} foi removido deste item.`)
                    this.$emit('itemAtualizado');
                }
                else this.$toast.error(`Falha ao remover o item ${vencedorItem.IdParticipanteItemLicitacao}.`)
            }
        } catch (e: any) {
            this.tratarError(e)
        }
    }

    /**
     * Limpa a tela e abre o formulário de novo vencedor
     */
    async criarNovoVencedor() {
        //ir para última página
        await this.pageChange(Math.floor(this.totalRowsItens / this.pageSize) + 1)
        //criar lote vazio, colocar no final do array
        const novoVencedorItem = new VencedorItem()
        novoVencedorItem.modoEdicao = true
        novoVencedorItem.IdItemLicitacao = this.itemComVencedores.IdItemLicitacao
        //tá faltando colocar o sequencialote aqui
        this.itemComVencedores.Vencedores.push(novoVencedorItem)
        this.$emit('input', this.itemComVencedores.Vencedores);
    }

    async ativarModoEdicaoVencedorItem(vencedor: VencedorItem): Promise<void> {
        const meuVencedor = this.itemComVencedores.Vencedores.find(lo => lo.IdParticipanteLicitacao === vencedor.IdParticipanteLicitacao)
        if (meuVencedor) {
            this.fecharTodasRows()
            meuVencedor.modoEdicao = true
            meuVencedor._rowVariant = 'active'
            meuVencedor._showDetails = true
        }
    }

    async desativarModoEdicaoVencedorItem(vencedor: VencedorItem): Promise<void> {
        const meuLote = this.itemComVencedores.Vencedores.find(lo => lo.IdParticipanteLicitacao === vencedor.IdParticipanteLicitacao)
        if (meuLote) {
            meuLote.modoEdicao = false
            meuLote._rowVariant = ''
        }
    }

    async atualizarVencedor(lvl: VencedorItem, lvlAtualizado: VencedorItem): Promise<void> {
        try {
            const novoLvl = Object.assign(lvl, lvlAtualizado)
            this.trocarLvl(lvl, novoLvl)
            this.$toast.success(`O lote ${novoLvl.Vencedor} foi atualizado!`)
        } catch (e: any) {
            this.tratarError(e)
        }
    }

    trocarLvl(antigo, novo) {
        const index = this.itemComVencedores.Vencedores.indexOf(antigo)
        this.itemComVencedores.Vencedores.splice(index, 1, novo)
        this.$emit('input', this.itemComVencedores.Vencedores);
    }
    fecharTodasRows() {
        this.itemComVencedores.Vencedores.forEach(item => item._showDetails = false)
        this.$emit('input', this.itemComVencedores.Vencedores);
    }

    async buscarParticipantes(): Promise<void> {
        try {
            this.tableBusy = true
            const response = await ldiService.buscarParticipantes(this.itemComVencedores.IdLicitacao)
            if (response) {
                //console.log('peguei os participantes', response)
                this.participantes = response.participantes.map(p => {
                    const item = Object.assign(new ParticipanteLicitacao(), p)
                    return item
                });
            } else {
                this.$toast.error('Erro ao consultar os participantes da licitação.');
            }
        } catch (e) {
            console.error(e)
            this.$toast.error('Falha ao buscar participantes. ' + e)
        } finally {
            this.tableBusy = false
        }
    }
}


</script>

<style>
a.disabled {
    pointer-events: none;
    color: gray !important;
}

#participanteSelectWrapper.invalid .multiselect__tags {
    border: #dc3545 solid 1px !important;
    border-radius: 3px !important;
}

#participanteSelectWrapper.valid .multiselect__tags {
    border: #28a745 solid 1px !important;
    border-radius: 3px !important;
}

#participanteSelectWrapper label {
    width: 100%;
    margin-top: 0.25rem;
    font-size: 80%;
    color: #dc3545;
    text-align: left;
}
</style>